var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUsdtSol = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_623_798)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_623_798)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.85921 3.13261L0.0244914 15.02C0.0022886 15.0642 -0.00474733 15.1142 0.00441255 15.1626C0.0135724 15.2109 0.0384476 15.2552 0.0754003 15.2889L15.8336 29.9351C15.8783 29.9767 15.938 30 16 30C16.062 30 16.1216 29.9767 16.1664 29.9351L31.9246 15.2898C31.9615 15.2561 31.9864 15.2119 31.9956 15.1635C32.0047 15.1151 31.9977 15.0652 31.9755 15.0209L26.1407 3.13352C26.1219 3.0936 26.0916 3.05978 26.0535 3.03611C26.0154 3.01243 25.9711 2.9999 25.9258 3.00002H6.07605C6.03057 2.99947 5.9859 3.0117 5.94742 3.03522C5.90895 3.05875 5.87831 3.09257 5.85921 3.13261Z",
    fill: "#009393"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0246 16.2408C17.9114 16.249 17.3269 16.2828 16.0231 16.2828C14.9861 16.2828 14.2498 16.2527 13.9915 16.2408C9.9838 16.0698 6.99243 15.3931 6.99243 14.5829C6.99243 13.7728 9.9838 13.097 13.9915 12.9233V15.5668C14.2535 15.5851 15.004 15.6281 16.041 15.6281C17.2855 15.6281 17.9086 15.5778 18.0208 15.5678V12.9251C22.02 13.0979 25.0048 13.7746 25.0048 14.5829C25.0048 15.3913 22.0209 16.0679 18.0208 16.2399L18.0246 16.2408ZM18.0246 12.6517V10.2861H23.6057V6.67871H8.41034V10.2861H13.9905V12.6508C9.45492 12.8529 6.04402 13.7243 6.04402 14.7686C6.04402 15.8128 9.45492 16.6834 13.9905 16.8864V24.4669H18.0236V16.8836C22.5489 16.6815 25.9541 15.811 25.9541 14.7676C25.9541 13.7243 22.5517 12.8538 18.0236 12.6508L18.0246 12.6517Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24 32C28.4183 32 32 28.4183 32 24C32 19.5817 28.4183 16 24 16C19.5817 16 16 19.5817 16 24C16 28.4183 19.5817 32 24 32Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_623_798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6243 26.1059C20.6847 26.0443 20.7677 26.0084 20.8557 26.0084H28.8365C28.9824 26.0084 29.0553 26.188 28.9522 26.2933L27.3756 27.9025C27.3153 27.9641 27.2323 28 27.1443 28H19.1634C19.0176 28 18.9447 27.8204 19.0478 27.7151L20.6243 26.1059Z",
    fill: "url(#paint0_linear_623_798)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6243 20.0975C20.6871 20.0359 20.7701 20 20.8556 20H28.8365C28.9823 20 29.0552 20.1797 28.9522 20.2849L27.3756 21.8941C27.3152 21.9557 27.2323 21.9917 27.1443 21.9917H19.1634C19.0175 21.9917 18.9446 21.812 19.0477 21.7068L20.6243 20.0975Z",
    fill: "url(#paint1_linear_623_798)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3756 23.0825C27.3153 23.0209 27.2323 22.9849 27.1443 22.9849H19.1634C19.0176 22.9849 18.9447 23.1646 19.0478 23.2698L20.6243 24.8791C20.6847 24.9407 20.7677 24.9766 20.8557 24.9766H28.8365C28.9824 24.9766 29.0553 24.7969 28.9522 24.6917L27.3756 23.0825Z",
    fill: "url(#paint2_linear_623_798)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_623_798",
    x1: 28.0741,
    y1: 19.0387,
    x2: 22.3706,
    y2: 29.7415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_623_798",
    x1: 25.6589,
    y1: 17.7516,
    x2: 19.9554,
    y2: 28.4545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_623_798",
    x1: 26.8589,
    y1: 18.3911,
    x2: 21.1553,
    y2: 29.0939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_623_798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_623_798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 27,
    fill: "white",
    transform: "translate(0 3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_623_798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 8,
    fill: "white",
    transform: "translate(19 20)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUsdtSol);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/USDT_SOL.d759e4c03bcbb59dcc9bab4c7615c199.svg";